import React, {useContext, useEffect, useRef, useState} from 'react';
import axios from "axios";
import Datatables, {getCheckedItems} from "../component/Datatables";
import Modal from 'react-modal';
import {getLoginUser} from "../../helper/SecurityHelper";
import {toast} from "react-toastify";
import messageCodeDic from "../../util/messageCodeDic";
import errorCodeDic from "../../util/errorCodeDic";
import BMCSelect from "../../components/common/BMCSelect";
import {CmmnFn} from "../../helper/CmmnHelper";
import {ProgressContext} from "../../context/Progress";
import SHSearch from '../component/BMCSearch';
import {Col, Container, Row, Table} from 'react-bootstrap';
import SubMenuTitle from "../component/SubMenuTitle";
import BMCIconButton from '../../components/common/BMCIconButton';
import {UserContext} from "../../context/User";
import BMCInput from "../../components/common/BMCInput";
import BMCDatePicker from "../../components/common/BMCDatePicker";
import CustomDatePickerRange from "../component/ui/DatePickerRange";
import BMCRangeDatePicker from "../../components/common/BMCRangeDatePicker";
import BMCCheckbox from "../../components/common/BMCCheckbox";
import SmrtSftyEqmntRgstModal from "./modal/SmrtSftyEqmntRgstModal";
import CustomDatePicker from '../component/ui/DatePicker';


type Props = {};

Modal.setAppElement('#root');
const SmrtSftyEqmntPage = (props: Props) => {
    const [dataList, setDataList] = useState<any[]>([]);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [detailData, setDetailData] = useState(null);
    const [isSaveSuccess, setIsSaveSuccess] = useState(false);
    const defaultUser = getLoginUser();
    const srchTxtRef = useRef<any>();
    const [srchData, setSrchData] = useState<any>()
    const {spinner} = useContext(ProgressContext);
    const searchFormRef = useRef<any>();
    const [datatable, setDatatable] = useState<any>();
    const {user} = useContext<any>(UserContext);
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [isStartDatePopupOpen, setIsStartDatePopupOpen] = useState(false);
    const [isEndDatePopupOpen, setIsEndDatePopupOpen] = useState(false);
    const prodRef = useRef<any>();


    useEffect(() => {
        setStartDate(CmmnFn.dateFormat(-2));
        setEndDate(CmmnFn.dateFormat(1));
    }, [])

    useEffect(()=>{

        if(datatable){
            datatable.draw();
        }

    }, [user, datatable])

    useEffect(() => {
        if (!modalIsOpen) {
            datatable?.draw();
        }
    }, [modalIsOpen])

    const fn_startDatePopupOpen = () => {
        setIsStartDatePopupOpen(!isStartDatePopupOpen);
        setIsEndDatePopupOpen(false);
    };
    const fn_endDatePopupOpen = () => {
        setIsEndDatePopupOpen(!isEndDatePopupOpen);
        setIsStartDatePopupOpen(false);
    };

    const fn_setSearchData = (e: any) => {

        if (e.target.type == 'checkbox') {
            setSrchData({
                ...srchData,
                [e.target.name]: e.target.checked
            })
        } else {

            setSrchData({
                ...srchData,
                [e.target.name]: e.target.value
            })
        }
    }

    const fn_search = (e?: any) => {

        if (e) {
            e.preventDefault()
        }
        datatable.draw();

        setIsSaveSuccess(false);
    }

    const fn_delete = () => {
        var checkedData = getCheckedItems(datatable);
        let delList: number[] = [];

        if (checkedData.length == 0) {
            toast.warn(messageCodeDic['005']);
            return;
        }

        checkedData.map((data: any) => {
            delList.push(data.smrtEqmntId);
        })

        console.log('delList: ', delList);

        if (!window.confirm(messageCodeDic['004'])) {
            return;
        }


        axios.post('/admin/api/smrtSftyEqmnt/deleteSmrtSftyEqmntData', {delList: delList}).then(rsltData => {
                if (rsltData.data > 0) {
                    toast.success(messageCodeDic['002'])
                    fn_search();
                } else {
                    toast.error(errorCodeDic['003'])
                }

            }
        ).catch(() => {
                toast.error(errorCodeDic['003'])
            }
        )
    }


    const fn_registPopOpen = () => {
        setDetailData(null);
        setModalIsOpen(true);
    }



    const fn_onIsAllProdChg = (e:any) => {
        if(e.target.value){
            setStartDate('');
            setEndDate('');
        }
    }

    return (
        <Container fluid className="bg-white px-0 bmc-txt-color-primary">
            <SubMenuTitle title={'스마트 안전장비'} parentMenu={'스마트 안전장비'}/>

            <SmrtSftyEqmntRgstModal setModalIsOpen={setModalIsOpen} modalIsOpen={modalIsOpen} detailData={detailData} siteId={user?.blngSiteId || defaultUser.blngSiteId} />

            <div className="p-4 overflow-y-auto" style={{height: 'calc(100vh - 180px)'}}>
                <SHSearch datatable={datatable} formRef={searchFormRef} btnType={'p'}>
                    <Row>
                        <Col>
                            <Table className="bmc-font-SP bmc-fs-b2 my-3">
                                <tbody>
                                <tr className="border-top border-bottom align-middle">
                                    <th className="bmc-bg-th">구분</th>
                                    <td>
                                        <BMCInput type={'hidden'} name={'siteId'} value={user?.blngSiteId || defaultUser.blngSiteId} />
                                        <BMCSelect initOptionGb={'all'} name={'eqmntGb'} codeGb={'cmmn'} codeGrpId={'E003'} className={"min-w-[100px]"}
                                                   onChange={fn_setSearchData}
                                                   value={srchData?.eqmntGb}></BMCSelect>
                                    </td>
                                    <th className="bmc-bg-th">기간</th>
                                    <td>
                                        <div className="d-flex align-items-center w-100">
                                        <BMCDatePicker
                                            className={"text-center"}
                                            readOnly={true}
                                            value={startDate}
                                            name={"strtDt"}
                                            onClick={fn_startDatePopupOpen}
                                            onChange={fn_setSearchData}
                                            calendar={fn_startDatePopupOpen}
                                            disabled={srchData?.isAllProd || false}
                                        />
                                        <span>&nbsp;~&nbsp;</span>
                                        <BMCDatePicker
                                            readOnly={true}
                                            className={"text-center"}
                                            value={endDate}
                                            name={"endDt"}
                                            onClick={fn_endDatePopupOpen}
                                            onChange={fn_setSearchData}
                                            calendar={fn_endDatePopupOpen}
                                            disabled={srchData?.isAllProd || false}
                                        />
                                        {isStartDatePopupOpen
                                            ? <CustomDatePicker setIsDatePopupOpen={setIsStartDatePopupOpen}
                                                                    prodRef={prodRef}
                                                                    setDateView={setStartDate}/>
                                            : null}
                                        {isEndDatePopupOpen
                                            ? <CustomDatePicker setIsDatePopupOpen={setIsEndDatePopupOpen}
                                                                    prodRef={prodRef}
                                                                    setDateView={setEndDate}/>
                                            : null}
                                            <BMCCheckbox name={'isAllProd'} onChange={(e: any) => {fn_setSearchData(e); fn_onIsAllProdChg(e);}}
                                                         checked={srchData?.isAllProd} className={'ml-3 w-[110px]'}>전체기간</BMCCheckbox>
                                        </div>
                                    </td>

                                    <th className="bmc-bg-th">검색어</th>
                                    <td className="w-[40%]">
                                        <input type={'text'} name={'srchTxt'} className='form-control' ref={srchTxtRef}/>
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </SHSearch>


                <div className='w-100 d-flex justify-content-end align-items-center mb-2'>
                    <BMCIconButton kind={'submit'} marginRight={'5px'} onClick={fn_registPopOpen}>등록</BMCIconButton>
                    <BMCIconButton kind={'delete'} marginRight={'0'} onClick={fn_delete}>삭제</BMCIconButton>
                </div>

                <div className={'ge-result'}>
                    <Datatables
                        dataUrl={'/admin/api/smrtSftyEqmnt/retrieveSmrtSftyEqmntDataList'}
                        parameterFormRef={searchFormRef}
                        columns={[
                            {data: "eqmntGbNm", title: "구분"},
                            {data: "prdctNm", title: "제품명"},
                            {data: "cmpnyNm", title: "업체"},
                            {data: "rgstrNm", title: "작성자"},
                            {data: "rgstDt", title: "작성일"},

                        ]}
                        checked={true}
                        index={true}

                        onLoad={(dt: any) => {
                            setDatatable(dt)
                        }}
                        onClick={(data) => {
                            setDetailData(data)
                            setModalIsOpen(true);
                        }
                        }
                    />
                </div>
            </div>
        </Container>


    );
};

export default SmrtSftyEqmntPage;
